import React, { useState, useEffect } from 'react';
import axios, { renderDoc, decryptData } from '../Axiosinstance';
import {
  TextField, Button, Grid, CircularProgress, Autocomplete, Slide, Typography, Container, MenuItem, Modal, Box, TableContainer, Select, InputLabel, FormControl, IconButton, Paper, Dialog, DialogActions, DialogContent, DialogTitle, RadioGroup, FormControlLabel, Radio, Card, CardContent, Tooltip, Table, Checkbox, TableRow, TableBody, TableCell, TableHead, Menu, Snackbar, Alert
} from '@mui/material';

import { Add, Remove } from '@mui/icons-material';
import { Navigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Upload } from '@mui/icons-material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { InputAdornment } from '@mui/material';
import { buttonBackgroundColor, logoImage, validateIdentityNumber } from '../common';
import { useNavigate } from 'react-router-dom';
import LinearProgress from '@mui/material/LinearProgress';
import './registration.css'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
// import 'react-phone-input-2/lib/material.css'
// import { GetCountries } from 'react-country-state-city';
import { Country as CountryData } from 'country-state-city';
import dayjs from 'dayjs';
import * as pdfjs from "pdfjs-dist/build/pdf";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";
import * as pdfjsLib from "pdfjs-dist";
import "pdfjs-dist/build/pdf.worker.entry";
pdfjs.GlobalWorkerOptions.workerSrc = pdfWorker;



function App() {
  const navigate = useNavigate();

  const { batchId } = useParams();
  const [enStartDate, setEnStartDate] = useState("");
  const [enCurrentModule, setEnCurrentModule] = useState("");
  const [enType, setEnType] = useState("");
  const [batchSummary, setBatchSummary] = useState(null);
  const [countryValid, setCountryValid] = useState(true);
  const [batchDataFetched, setBatchDataFetched] = useState(false);
  const [retryingBatchFetch, setRetryingBatchFetch] = useState(false);
  const [contactAdmin, setContactAdmin] = useState(false);
  const [adminMessage, setAdminMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };



  // useEffect(() => {
  //   if (!batchId || !enStartDate || !enCurrentModule || !enType) {
  //     // console.warn("Unauthorized access attempt detected.");
  //      navigate("/publicCoursese"); // Redirects away from Registration
  //   }
  // }, [batchId, enStartDate, enCurrentModule, enType, navigate]);

  useEffect(() => {
    if (!batchId) {
      // console.warn("Unauthorized access attempt detected.");
      navigate("/publicCoursese"); // Redirects away from Registration
    }
  }, [batchId, navigate]);


  const [paymentSessionUrl, setPaymentSessionUrl] = useState('');
  const [editedStudent, setEditedStudent] = useState(false);
  const [dataResponse, setDataResponse] = useState([]);
  const [fetchedOrNot, setFetchedOrNot] = useState(false);
  const [dialogClass, setDialogClass] = useState('');
  const [submissionSuccess, setSubmissionSuccess] = useState(false);



  // console.log("hdhd", batchId, startDate, currentModule, type);
  // console.log("Data types:", typeof batchId, typeof startDate, typeof currentModule, typeof type);
  const [value, setValue] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [studentNameError, setStudentNameError] = useState('');
  const [proofTypeError, setProofTypeError] = useState('');
  const [nricError, setNricError] = useState('');
  const [emailErrors, setEmailErrors] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [passportNoError, setPassportNoError] = useState('');
  const [addressError, setAddressError] = useState('');
  const [handPhoneError, setHandPhoneError] = useState('');
  const [loadingButton, setLoadingButton] = useState(null);
  const [errors, setErrors] = useState({
    workPermitSpass: false,

  });
  const [confirmationOpen, setConfirmationOpen] = useState(false);





  useEffect(() => {
    if (!batchId) return;

    axios.get("/batch-summary")
      .then(response => {
        const batchData = response.data.find(batch => batch.id == batchId);

        if (batchData) {
          //    setEnStartDate(batchData.startDate);
          setEnType(batchData.type);
          // alert(batchData.type)

          // Ensure batchData is properly passed to handleDateChange
          const calculatedModule = handleDateChange(batchData);
          if (calculatedModule !== undefined) {
            setEnCurrentModule(calculatedModule);
            // alert(calculatedModule)

            setBatchDataFetched(true);
          } else {
            console.warn("handleDateChange returned undefined. Check batchData:", batchData);
          }
        } else {
          console.warn("Batch with the given ID not found");
        }
      })
      .catch(error => console.error("Error fetching batch summary:", error));
  }, [batchId]);



  const handleDateChange = (batch) => {

    const newDate = dayjs(); // Create dayjs object from the new date;
    const intakeStartDate = batch?.intakeStartDate ? dayjs(batch.intakeStartDate) : null;
    const isDatePassed = intakeStartDate && newDate.isAfter(intakeStartDate);

    if (batch?.status && !isDatePassed) {
      console.log("Batch is active. Using current module:", batch?.currentModule);
      return batch.currentModule; // Exit function
    }

    const oldDate = dayjs();
    // const { value } = event.target;
    // console.log("Selected Enrollment Date:", value, "| Type:", typeof value);
    // const newDate = dayjs(value);
    // const oldDate = dayjs('2025-01-14');
    console.log("Current Date:", oldDate.format('YYYY-MM-DD'));
    console.log("New Date:", newDate.format('YYYY-MM-DD'));
    console.log("New Date Valid?", newDate.isValid());

    // Check for invalid date handling
    if (!newDate.isValid()) {
      console.error("Invalid newDate detected. Check input format.");
      return;
    }

    let monthDifference = newDate.month() - oldDate.month();
    if (newDate.year() !== oldDate.year()) {
      monthDifference += (newDate.year() - oldDate.year()) * 12;
    }
    console.log("Month Difference:", monthDifference);

    console.log("Form Data Type:", batch?.type);

    let increment = 0;
    if (batch?.type === 'diploma') {
      // Check if the oldDate month is odd or even
      if (oldDate.month() % 2 === 1) {
        // For odd months, increment by 1 for every odd month difference
        increment = Math.floor((monthDifference + 1) / 2);
      } else {
        // For even months, increment by 1 for every 2 months
        increment = Math.floor(monthDifference / 2);
      }
      console.log("Diploma Course - Increment:", increment);
    } else if (batch?.type === 'advance_diploma') {
      // For advance diploma, increment by the full month difference
      increment = monthDifference;
      console.log("Advance Diploma Course - Increment:", increment);
    } else {
      console.warn("Unknown formData.type detected:", batch?.type);
    }

    console.log("Initial Modulus:", batch.currentModule);


    // Adjust the modulus based on the increment
    let newModulus = batch.currentModule + increment;
    newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1; // Ensure modulus stays within 1-6
    console.log("New Modulus After Adjustments:", newModulus);

    const firstDayOfMonth = newDate.startOf('month');

    // First Saturday
    let firstSaturday = firstDayOfMonth.day(6);
    if (firstSaturday.isBefore(firstDayOfMonth)) {
      firstSaturday = firstSaturday.add(7, 'days');
    }

    // First Sunday
    let firstSunday = firstDayOfMonth.day(0);
    if (firstSunday.isBefore(firstDayOfMonth)) {
      firstSunday = firstSunday.add(7, 'days');
    }

    console.log("First Saturday of the Month:", firstSaturday.format('YYYY-MM-DD'));
    console.log("First Sunday of the Month:", firstSunday.format('YYYY-MM-DD'));

    console.log("before updating  New Modulus:", newModulus);

    if (batch?.type === 'diploma') {
      const isEvenMonth = (newDate.month() + 1) % 2 === 0;
      console.log("Is Even Month:", isEvenMonth);

      if (isEvenMonth) {
        newModulus += 1;
        console.log("Diploma - Even Month: Adjusting Modulus by adding 1.");
      } else {
        if (newDate.isAfter(firstSaturday) || newDate.isAfter(firstSunday)) {
          newModulus += 1;
          console.log("Diploma - Odd Month: Adjusting Modulus by adding 1 after first Saturday/Sunday.");
        }
      }
    } else if (batch?.type === 'advance_diploma') {

      console.log((oldDate.month()), "oldDate");
      console.log((oldDate.month() + 1) % 2, "oldDate");
      if ((oldDate.month() + 1) % 2 === 1) {
        if (newDate.isAfter(firstSunday)) {
          newModulus += 1;
          console.log("Advance Diploma - Adjusting Modulus by adding 1.");
        }
      }


      else if ((oldDate.month() + 1) % 2 === 0) {
        if (newDate.isAfter(firstSunday)) {
          newModulus += 1;
          console.log("Advance Diploma - Adjusting Modulus by adding 1.", (oldDate.month()));
        }
        else {
          newModulus = newModulus;
          console.log("hiihih", (oldDate.month()));
        }
      }
    }

    newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1;
    console.log("Final New Modulus:", newModulus);


    // setInitialModulus(newModulus);
    console.log("newModulus", newModulus)
    return newModulus;
  };


  const [formData, setFormData] = useState({
    studentName: "",
    studentEmail: "",
    batchId: batchId,
    startModulus: enCurrentModule,
    enrollmentDate: new Date().toISOString().split('T')[0],
    nric: "",
    proofType: "",
    phone: "",
    email: "",
    gender: "",
    dob: "",
    password: "",
    type: enType,
    sureName: "",
    countryBirth: "",
    nationality: "",
    NRICno: "",
    passportNo: "",
    addressOffice: "",
    addressHome: "",
    phoneOffice: "",
    phoneHome: "",
    handPhone: "",
    emergencyName: "",
    emergencyRelation: "",
    emergencyPhone: "",
    knowAboutProgram: "",
    applicationSignature: "",
    emergencyOtherDetails: "",
    nonSingaporean: "",
    company: "",
    photo: "",
    approve: "false",
    sessionId: null,
    sessionIdDate: null,
    approveReference: "",
    // paymentStatus: "Pending",
    paymentType: "online",
    institutionDetails: [],

    workPermitSpass: '',
    workPermitOne: '',
    repass: '',
    dependentPass: '',
    passport: '',
    markSheet: {
      level1: ''
    },
    certificate: {
      level1: ''
    },
    transcript: '',
    profilePicture: '',
    workPermitOne: '',
    workPermitSpassProgress: 0,
    workPermitSpassStatus: '',
    workPermitOneProgress: 0,
    workPermitOneStatus: '',
    transcriptProgress: 0,
    transcriptStatus: '',
    passportProgress: 0,
    passportStatus: '',
    profilePictureProgress: 0,
    profilePictureStatus: '',
    workPermitOneProgress: 0,
    workPermitOneStatus: '',
    workPermitSpassUrl: '',
    workPermitOneUrl: '',
    transcriptUrl: '',
    passportUrl: '',
    profilePictureUrl: '',
    workPermitOneUrl: '',
    otherDetails: '',
    markSheetFileNames: {},
    certificateFileNames: {},
    workPermitSpassFileName: '',
    workPermitOneFileName: '',
    passportFileName: '',
    profilePictureFileName: '',
    workPermitOneFileName: '',
    referalfriend: ''
  });

  const [countriesList, setCountriesList] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    axios.get("/home/usertype?types=3")
      .then(response => {
        const usersData = response.data.map(user => ({
          id: user.id,
          name: user.name,
          email: user.email
        }));
        setUsers(usersData);
      })
      .catch(error => {
        console.error('Error fetching users:', error);
      });
  }, []);

  const handleSelectChange = (event) => {
    const selectedUserName = event.target.value;
    const selectedUser = users.find(user => user.name === selectedUserName);

    if (selectedUser) {
      setFormData({ ...formData, approveReference: selectedUser.id });
      setSelectedUserId(selectedUser.id);
    } else {
      // Handle the case where the user is not found, if necessary
      console.error("User not found:", selectedUserName);
      setFormData({ ...formData, approveReference: '' });
      setSelectedUserId('');
    }
  };

  const nationalityMapping = {
    'Afghanistan': 'Afghan', 'Albania': 'Albanian', 'Algeria': 'Algerian', 'Andorra': 'Andorran', 'Angola': 'Angolan', 'Antigua and Barbuda': 'Antiguan or Barbudan', 'Argentina': 'Argentine', 'Armenia': 'Armenian',
    'Australia': 'Australian', 'Austria': 'Austrian', 'Azerbaijan': 'Azerbaijani', 'Bahamas': 'Bahamian', 'Bahrain': 'Bahraini', 'Bangladesh': 'Bangladeshi', 'Barbados': 'Barbadian', 'Belarus': 'Belarusian',
    'Belgium': 'Belgian', 'Belize': 'Belizean', 'Benin': 'Beninese', 'Bhutan': 'Bhutanese', 'Bolivia': 'Bolivian', 'Bosnia and Herzegovina': 'Bosnian', 'Botswana': 'Botswana', 'Brazil': 'Brazilian',
    'Brunei': 'Bruneian', 'Bulgaria': 'Bulgarian', 'Burkina Faso': 'Burkinabé', 'Burundi': 'Burundian', 'Cabo Verde': 'Cape Verdean', 'Cambodia': 'Cambodian', 'Cameroon': 'Cameroonian', 'Canada': 'Canadian',
    'Central African Republic': 'Central African', 'Chad': 'Chadian', 'Chile': 'Chilean', 'China': 'Chinese', 'Colombia': 'Colombian', 'Comoros': 'Comorian', 'Congo': 'Congolese', 'Congo, Democratic Republic of the': 'Congolese',
    'Costa Rica': 'Costa Rican', 'Croatia': 'Croatian', 'Cuba': 'Cuban', 'Cyprus': 'Cypriot', 'Czech Republic': 'Czech', 'Denmark': 'Danish', 'Djibouti': 'Djiboutian', 'Dominica': 'Dominican',
    'Dominican Republic': 'Dominican', 'Ecuador': 'Ecuadorian', 'Egypt': 'Egyptian', 'El Salvador': 'Salvadoran', 'Equatorial Guinea': 'Equatorial Guinean', 'Eritrea': 'Eritrean', 'Estonia': 'Estonian',
    'Eswatini': 'Swazi', 'Ethiopia': 'Ethiopian', 'Fiji': 'Fijian', 'Finland': 'Finnish', 'France': 'French', 'Gabon': 'Gabonese', 'Gambia': 'Gambian', 'Georgia': 'Georgian', 'Germany': 'German',
    'Ghana': 'Ghanaian', 'Greece': 'Greek', 'Grenada': 'Grenadian', 'Guatemala': 'Guatemalan', 'Guinea': 'Guinean', 'Guinea-Bissau': 'Guinean', 'Guyana': 'Guyanese', 'Haiti': 'Haitian', 'Honduras': 'Honduran',
    'Hungary': 'Hungarian', 'Iceland': 'Icelandic', 'India': 'Indian', 'Indonesia': 'Indonesian', 'Iran': 'Iranian', 'Iraq': 'Iraqi', 'Ireland': 'Irish', 'Israel': 'Israeli', 'Italy': 'Italian',
    'Jamaica': 'Jamaican', 'Japan': 'Japanese', 'Jordan': 'Jordanian', 'Kazakhstan': 'Kazakh', 'Kenya': 'Kenyan', 'Kiribati': 'I-Kiribati', 'Korea, North': 'North Korean', 'Korea, South': 'South Korean',
    'Kosovo': 'Kosovar', 'Kuwait': 'Kuwaiti', 'Kyrgyzstan': 'Kyrgyz', 'Laos': 'Laotian', 'Latvia': 'Latvian', 'Lebanon': 'Lebanese', 'Lesotho': 'Lesotho', 'Liberia': 'Liberian', 'Libya': 'Libyan',
    'Liechtenstein': 'Liechtensteiner', 'Lithuania': 'Lithuanian', 'Luxembourg': 'Luxembourgish', 'Madagascar': 'Malagasy', 'Malawi': 'Malawian', 'Malaysia': 'Malaysian', 'Maldives': 'Maldivian',
    'Mali': 'Malian', 'Malta': 'Maltese', 'Marshall Islands': 'Marshallese', 'Mauritania': 'Mauritanian', 'Mauritius': 'Mauritian', 'Mexico': 'Mexican', 'Micronesia': 'Micronesian', 'Moldova': 'Moldovan',
    'Monaco': 'Monacan', 'Mongolia': 'Mongolian', 'Montenegro': 'Montenegrin', 'Morocco': 'Moroccan', 'Mozambique': 'Mozambican', 'Myanmar': 'Burmese', 'Namibia': 'Namibian', 'Nauru': 'Nauruan',
    'Nepal': 'Nepali', 'Netherlands': 'Dutch', 'New Zealand': 'New Zealander', 'Nicaragua': 'Nicaraguan', 'Niger': 'Nigerien', 'Nigeria': 'Nigerian', 'North Macedonia': 'Macedonian',
    'Norway': 'Norwegian', 'Oman': 'Omani', 'Pakistan': 'Pakistani', 'Palau': 'Palauan', 'Palestine': 'Palestinian', 'Panama': 'Panamanian', 'Papua New Guinea': 'Papua New Guinean',
    'Paraguay': 'Paraguayan', 'Peru': 'Peruvian', 'Philippines': 'Filipino', 'Poland': 'Polish', 'Portugal': 'Portuguese', 'Qatar': 'Qatari', 'Romania': 'Romanian', 'Russia': 'Russian',
    'Rwanda': 'Rwandan', 'Saint Kitts and Nevis': 'Kittian or Nevisian', 'Saint Lucia': 'Saint Lucian', 'Saint Vincent and the Grenadines': 'Vincentian', 'Samoa': 'Samoan', 'San Marino': 'Sammarinese',
    'Sao Tome and Principe': 'Sao Tomean', 'Saudi Arabia': 'Saudi', 'Senegal': 'Senegalese', 'Serbia': 'Serbian', 'Seychelles': 'Seychellois', 'Sierra Leone': 'Sierra Leonean', 'Singapore': 'Singaporean',
    'Slovakia': 'Slovak', 'Slovenia': 'Slovenian', 'Solomon Islands': 'Solomon Islander', 'Somalia': 'Somali', 'South Africa': 'South African', 'South Sudan': 'South Sudanese', 'Spain': 'Spanish',
    'Sri Lanka': 'Sri Lankan', 'Sudan': 'Sudanese', 'Suriname': 'Surinamese', 'Sweden': 'Swedish', 'Switzerland': 'Swiss', 'Syria': 'Syrian', 'Taiwan': 'Taiwanese', 'Tajikistan': 'Tajik',
    'Tanzania': 'Tanzanian', 'Thailand': 'Thai', 'Timor-Leste': 'Timorese', 'Togo': 'Togolese', 'Tonga': 'Tongan', 'Trinidad and Tobago': 'Trinidadian or Tobagonian', 'Tunisia': 'Tunisian',
    'Turkey': 'Turkish', 'Turkmenistan': 'Turkmen', 'Tuvalu': 'Tuvaluan', 'Uganda': 'Ugandan', 'Ukraine': 'Ukrainian', 'United Arab Emirates': 'Emirati', 'United Kingdom': 'British',
    'United States': 'American', 'Uruguay': 'Uruguayan', 'Uzbekistan': 'Uzbek', 'Vanuatu': 'Ni-Vanuatu', 'Vatican City': 'Vatican', 'Venezuela': 'Venezuelan', 'Vietnam': 'Vietnamese',
    'Yemen': 'Yemeni', 'Zambia': 'Zambian', 'Zimbabwe': 'Zimbabwean', 'Aland Islands': 'Alandic', "American Samoa": "American Samoan", "Anguilla": "Anguillian",
    "Antigua and Barbuda": "Antiguan and Barbudan", "Aruba": "Aruban", "Bermuda": "Bermudian", "Bonaire, Sint Eustatius and Saba": "Dutch Caribbean", "Bouvet Island": "Norwegian", "British Indian Ocean Territory": "British",
    "Cape Verde": "Cape Verdean", "Cayman Islands": "Caymanian", "Christmas Island": "Australian", "Cocos (Keeling) Islands": "Australian", "Cook Islands": "Cook Islander", "Cote d'Ivoire (Ivory Coast)": "Ivorian",
    "Curaçao": "Curacaon", "Democratic Republic of the Congo": "Congolese", "East Timor": "Timorese", "Falkland Islands": "Falklander or British", "Faroe Islands": "Faroese", "Fiji Islands": "Fijian",
    "French Guiana": "French Guianese", "French Polynesia": "French Polynesian", "French Southern Territories": "French", "Gambia, The": "Gambian", "Gibraltar": "Gibraltarian", "Greenland": "Greenlandic or Danish",
    "Guadeloupe": "Guadeloupean or French", "Guam": "Guamanian or American", "Guernsey and Alderney": "Guernsey and Alderney (Channel Islander)", "Heard Island and McDonald Islands": "Australian",
    "Hong Kong S.A.R.": "Hongkonger", "Jersey": "Jersey (Channel Islander)", "Macau S.A.R.": "Macanese", "Macedonia": "Macedonian", "Man (Isle of)": "Manx", "Martinique": "Martiniquais",
    "Mayotte": "Mahoran", "Montserrat": "Montserratian", "New Caledonia": "New Caledonian", "Niue": "Niuean", "Norfolk Island": "Norfolk Islander", "North Korea": "North Korean", "Northern Mariana Islands": "Northern Marianan or American",
    "Palestinian Territory Occupied": "Palestinian", "Papua New Guinea": "Papua New Guinean", "Pitcairn Island": "Pitcairn Islander", "Puerto Rico": "Puerto Rican", "Réunion": "Réunionese or French",
    "Saint Helena": "Saint Helenian", "Saint Kitts and Nevis": "Kittitian or Nevisian", "Saint Pierre and Miquelon": "Saint-Pierrais or Miquelonnais", "Saint Vincent and the Grenadines": "Vincentian",
    "Saint-Barthélemy": "Saint-Barthélemy (French)", "Saint-Martin (French part)": "Saint-Martinois (French)", "Sint Maarten (Dutch part)": "Sint Maartener", "South Georgia": "British", "South Korea": "South Korean",
    "Svalbard and Jan Mayen Islands": "Svalbardian or Norwegian", "Swaziland": "Swazi", "The Bahamas": "Bahamian", "Tokelau": "Tokelauan", "Trinidad and Tobago": "Trinidadian or Tobagonian",
    "Turks and Caicos Islands": "Turks and Caicos Islander", "United States Minor Outlying Islands": "American", "Vatican City State (Holy See)": "Vatican or Papal", "Virgin Islands (British)": "British Virgin Islander",
    "Virgin Islands (US)": "American Virgin Islander", "Wallis and Futuna Islands": "Wallisian or Futunan", "Western Sahara": "Sahrawi", "Antigua and Barbuda": "Antiguan and Barbudan",
    "Cote d'Ivoire (Ivory Coast)": "Ivorian", "Gambia, The": "Gambian", "Papua New Guinea": "Papua New Guinean", "Réunion": "Réunionese or French", "Saint Kitts and Nevis": "Kittitian or Nevisian",
    "Saint Vincent and the Grenadines": "Vincentian", "Saint-Barthélemy": "Saint-Barthélemy (French)", "Svalbard and Jan Mayen Islands": "Svalbardian or Norwegian", "Trinidad and Tobago": "Trinidadian or Tobagonian",
    "Turks and Caicos Islands": "Turks and Caicos Islander", "Wallis and Futuna Islands": "Wallisian or Futunan"
  };

  // useEffect(() => {
  //   // Fetch the list of countries when the component mounts
  //   GetCountries().then((result) => {
  //     setCountriesList(result);
  //   });
  // }, []);
   useEffect(() => {
  const countries = CountryData.getAllCountries();
  setCountriesList(countries);
}, []);


  const prioritizeCountries = (countriesList) => {
    // Define the priority countries with specific order
    const priorityCountries = ['Singapore', 'Malaysia', 'India'];

    // Separate priority and non-priority countries
    const priorityList = countriesList
      .filter(country => priorityCountries.includes(country.name))
      .sort((a, b) => priorityCountries.indexOf(a.name) - priorityCountries.indexOf(b.name));

    const nonPriorityList = countriesList.filter(country =>
      !priorityCountries.includes(country.name)
    );

    // Concatenate priority and non-priority lists
    return [...priorityList, ...nonPriorityList];
  };

  const prioritizedCountriesList = prioritizeCountries(countriesList);



  const [emailError, setEmailError] = useState('');

  const checkEmailExists = async (email) => {
    console.log(email + "email")
    try {
      const response = await axios.get(`/home/check-email`, {
        params: { email }
      });
      return response.data; // Assume backend returns { available: true } if email is not in use
    } catch (error) {
      console.error('Error checking email:', error);
      return false;
    }
  };


  const [open, setOpen] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [studentDetails, setStudentDetails] = useState({ name: '', studentId: '' });

  const [alreadyRegistered, setAlreadyRegistered] = useState(false);
  const [unpaid, setUnpaid] = useState(false);


  const [registrationAdvance, setRegistrationadvance] = useState({ id: '' });
  const [anchorEl, setAnchorEl] = useState(null);

  // const [disableInputs, setDisableInputs] = useState(false);


  const SUPPORTED_FILE_TYPES = [
    'image/jpeg',
    'image/png',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ];


  const CLOUDINARY_URL = 'https://api.cloudinary.com/v1_1/dyjwwi8ea/raw/upload';
  const CLOUDINARY_UPLOAD_PRESET = 'vldqgwk8';

  const handleFileUpload = async (event, docType, index = null) => {
    const input = event.target;
    const file = event.target.files[0];
    if (!file) return;

    input.value = '';
    // Allowed file types for normal uploads
    const SUPPORTED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];

    if (!SUPPORTED_FILE_TYPES.includes(file.type)) {
      toast.error('Error: Unsupported file type! Please upload a .jpg, .jpeg, .png, or .pdf file.', {
        style: {
          backgroundColor: '#fff',
          color: 'black',
          fontWeight: 'normal',
        }
      });

      if (docType.startsWith("markSheet") || docType.startsWith("certificate")) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [docType.startsWith("markSheet") ? "markSheet" : "certificate"]: {
            ...prevFormData[docType.startsWith("markSheet") ? "markSheet" : "certificate"],
            [`level${index + 1}Status`]: 'Error: Unsupported file type',
            [`level${index + 1}Progress`]: 0,
          },
          [docType.startsWith("markSheet") ? "markSheetFileNames" : "certificateFileNames"]: {
            ...prevFormData[docType.startsWith("markSheet") ? "markSheetFileNames" : "certificateFileNames"],
            [`level${index + 1}`]: '',
          }
        }));
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [`${docType}Status`]: 'Error: Unsupported file type',
          [`${docType}Progress`]: 0,
          [`${docType}FileName`]: '',
        }));
      }

      return;
    }

    // If the file is a PDF and docType is profilePicture, convert to JPG
    if (file.type === 'application/pdf' && docType === 'profilePicture') {
      try {
        const firstPageJpgBlob = await convertPdfToJpg(file);
        const jpgFile = new File([firstPageJpgBlob], "converted-profile.jpg", { type: "image/jpeg" });

        // Upload the converted JPG file
        await uploadFile(jpgFile, docType, index);
      } catch (error) {
        console.error("Error converting PDF to JPG:", error);
        toast.error('Error converting PDF. Please try again.');
      }
    } else {
      // Upload normal file (JPG, PNG, etc.)
      await uploadFile(file, docType, index);
    }
  };

  // Function to upload file to Cloudinary
  const uploadFile = async (file, docType, index = null) => {
    setLoadingButton(docType);
    const uploadFormData = new FormData();
    uploadFormData.append('file', file);
    uploadFormData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);

    try {
      const response = await fetch(CLOUDINARY_URL, {
        method: 'POST',
        body: uploadFormData,
      });

      if (response.ok) {
        const data = await response.json();

        if (docType.startsWith("markSheet") || docType.startsWith("certificate")) {
          const isMarkSheet = docType.startsWith("markSheet");
          const section = isMarkSheet ? "markSheet" : "certificate";
          const fileNameKey = isMarkSheet ? "markSheetFileNames" : "certificateFileNames";

          setFormData((prevFormData) => ({
            ...prevFormData,
            [section]: {
              ...prevFormData[section],
              [`level${index + 1}`]: data.secure_url,
              [`level${index + 1}Progress`]: 100,
              [`level${index + 1}Status`]: 'Uploaded',
            },
            [fileNameKey]: {
              ...prevFormData[fileNameKey],
              [`level${index + 1}`]: file.name,
            }
          }));
        } else {
          setFormData((prevFormData) => ({
            ...prevFormData,
            [docType]: data.secure_url,
            [`${docType}Progress`]: 100,
            [`${docType}Status`]: 'Uploaded',
            [`${docType}FileName`]: file.name,
          }));
        }
        console.log(`${docType} uploaded successfully: ${data.secure_url}`);
      } else {
        toast.error('Error uploading file');
      }
    } catch (error) {
      toast.error('Error uploading file');
    } finally {
      setLoadingButton(null);
    }
  };

  // Function to convert first page of a PDF to JPG
  const convertPdfToJpg = async (pdfFile) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(pdfFile);

      reader.onload = async () => {
        const pdfData = new Uint8Array(reader.result);
        const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
        const page = await pdf.getPage(1);

        const scale = 2;
        const viewport = page.getViewport({ scale });
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        const renderContext = { canvasContext: context, viewport };
        await page.render(renderContext).promise;

        canvas.toBlob((blob) => {
          if (blob) resolve(blob);
          else reject("Error converting PDF page to image");
        }, "image/jpeg");
      };

      reader.onerror = (error) => reject(error);
    });
  };


  const resetUpload = (docType) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [`${docType}Progress`]: 0,
      [`${docType}Status`]: '',
      [`${docType}FileName`]: ''
    }));
  };




  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === 'nationality' || name === 'countryBirth') {
  //     // Find the country object from the countriesList using the selected country name
  //     const selectedCountry = countriesList.find((country) => country.name === value);

  //     // Store the country name directly in the formData
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [name]: selectedCountry ? selectedCountry.name : ''  // Store the country name directly
  //     }));
  //   } else if (['studentName', 'surname', 'emergencyName'].includes(name)) {
  //     // Validate alphabetic characters for specific fields
  //     if (/^[A-Za-z\s]*$/.test(value)) {
  //       setFormData((prevData) => ({
  //         ...prevData,
  //         [name]: value
  //       }));
  //     }
  //   } else {
  //     // For other fields, update the form data normally
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [name]: value
  //     }));
  //   }
  // };


  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'nationality' || name === 'countryBirth') {
      const selectedCountry = countriesList.find((country) => country.name === value);
      setFormData((prevData) => ({
        ...prevData,
        [name]: selectedCountry ? selectedCountry.name : ''
      }));
    } else if (name === 'proofType') {
      // When proofType changes, revalidate existing NRIC/FIN input
      const newProofType = value;
      const currentNric = formData.nric;
      const isValid = validateIdentityNumber(newProofType, currentNric.toUpperCase());
      setFormData((prevData) => ({
        ...prevData,
        [name]: newProofType
      }));
      setError(currentNric ? (isValid ? '' : `Invalid ${newProofType} format`) : '');
    } else if (name === 'nric') {
      const nricValue = value.toUpperCase();
      const isValid = validateIdentityNumber(formData.proofType, nricValue);
      setFormData((prevData) => ({
        ...prevData,
        [name]: nricValue
      }));
      setError(nricValue ? (isValid ? '' : `Invalid ${formData.proofType} format`) : '');
    }
    // } else if (['studentName', 'surname', 'emergencyName'].includes(name)) {
    //   // Validate alphabetic characters for specific fields
    //   if (/^[A-Za-z\s]*$/.test(value)) {
    //     setFormData((prevData) => ({
    //       ...prevData,
    //       [name]: value
    //     }));
    //   }
    else {
      // For other fields, update the form data normally
      setFormData((prevData) => ({
        ...prevData,
        [name]: value
      }));
    }
  };




  const handleKnowAboutProgramChange = (event) => {
    const value = event.target.value;
    setFormData((prevData) => ({
      ...prevData,
      knowAboutProgram: value,
      otherDetails: value !== 'other' ? '' : prevData.otherDetails // Clear otherDetails if not "other"
    }));
  };
  const handleOtherDetailsChange = (event) => {
    setFormData((prevData) => ({
      ...prevData,
      otherDetails: event.target.value
    }));
  };

  const handleReferalFriendChange = (event) => {
    setFormData((prevData) => ({
      ...prevData,
      referalfriend: event.target.value
    }));
  };




  const handleInstitutionChange = (index, e) => {
    const { name, value } = e.target;
    const newInstitutionDetails = formData.institutionDetails.map((institution, i) => {
      if (i === index) {
        return { ...institution, [name]: value };
      }
      return institution;
    });
    setFormData({
      ...formData,
      institutionDetails: newInstitutionDetails
    });
  };

  const addInstitution = () => {
    setFormData({
      ...formData,
      institutionDetails: [
        ...formData.institutionDetails,
        {
          institution: "",
          // toYear: "",
          year: "",
          fullTimeOrPartTime: "",
          qualificationsAchieved: ""
        }
      ]
    });
  };

  const removeInstitution = (index) => {
    const newInstitutionDetails = formData.institutionDetails.filter((_, i) => i !== index);
    setFormData({
      ...formData,
      institutionDetails: newInstitutionDetails
    });
  };

  const isPhoneEmpty = (phone) => {
    return !phone || /^\+\d{1,4}$/.test(phone.trim());
  };


  //modified
  const handleSubmit = (e) => {
    e.preventDefault();


    if (!formData.workPermitSpass) {
      setErrors(prevErrors => ({
        ...prevErrors,
        workPermitSpass: 'Please upload a file before submitting.'
      }));
      return;
    }

    if (isPhoneEmpty(formData.emergencyPhone)) {
      toast.error('Emergency contact number is required');
      return;
    }

    // Clear previous error messages for a successful submission
    setErrors(prevErrors => ({
      ...prevErrors,
      workPermitSpass: ''
    }));

    console.log("check", formData);
    const filteredFormData = Object.keys(formData).reduce((acc, key) => {
      if (formData[key] !== '' && formData[key] !== null && formData[key] !== undefined) {
        acc[key] = formData[key];
      }
      return acc;
    }, {});

    filteredFormData.markSheet = Object.keys(formData.markSheet).reduce((acc, key) => {
      if (formData.markSheet[key] !== '' && formData.markSheet[key] !== null && formData.markSheet[key] !== undefined) {
        acc[key] = formData.markSheet[key];
      }
      return acc;
    }, {});
    // alert(enType)
    const nationalityValue = nationalityMapping[formData.nationality] || '';
    const submissionData = {
      ...formData,
      type: enType,
      startModulus: enCurrentModule,
      knowAboutProgram: formData.knowAboutProgram === 'other' ? formData.otherDetails : formData.knowAboutProgram,
      knowAboutProgram: formData.knowAboutProgram === 'referal' ? formData.referalfriend : formData.knowAboutProgram,
      nationality: nationalityValue
    };
    console.log("before update", submissionData);
    setLoading(true);
    axios.post('/registrationadvances', submissionData)
      .then(response => {
        console.log("Full response: ", response);

        const { name, id: studentId } = response.data.student;
        const { id } = response.data;
        console.log("response.data", response.data);

        // setStudentDetails({ name, studentId });
        // setRegistrationadvance({ id });     
        setSubmissionSuccess(true);

        setOpen(true); // Open the payment modal

        // Display success message
        toast.success("Form submitted successfully");

        // Add fade-out class to dialog




      })
      .catch(error => {
        console.error("There was an error submitting the form!", error);
        toast.error("Error submitting the form. Please try again.");
      }).finally(() => {
        setLoading(false); // Set loading to false after API call
      });
  };




  const [page, setPage] = useState(0);


  const nextPage = async () => {
    // Extract form data for validation
    const { studentName, proofType, nric, email, nationality, gender, dob, password, countryBirth, passportNo, addressHome, handPhone, phoneHome } = formData;

    setStudentNameError('');
    setProofTypeError('');
    setNricError('');
    setEmailError('');
    setPasswordError('');
    setPassportNoError('');
    setAddressError('');
    setHandPhoneError('');

    // Validate required fields and show field-specific toast errors
    let isValid = true;

    if (!studentName || studentName.trim() === '') {
      toast.error('Student name is required');
      isValid = false;
    }

    if (!proofType || proofType.trim() === '') {
      toast.error('Proof type is required');
      isValid = false;
    }

    if (!dob || dob === '') { // Date of Birth validation
      toast.error('Date of Birth is required');
      isValid = false;
    }


    if (!nric || nric.trim() === '') {
      toast.error('NRIC is required');
      isValid = false;
    }

    if (!email || !validateEmail(email)) {
      toast.error('Invalid email format');
      isValid = false;
    }

    if (!gender || gender === '') {
      toast.error('Gender is required');
      isValid = false;
    }

    if (!countryBirth || countryBirth === '') {
      toast.error('Country of Birth is required');
      isValid = false;
    }

    if (!nationality || nationality === '') {
      toast.error('Nationality is required');
      isValid = false;
    }

    if (!password || !validatePassword(password)) {
      toast.error('Password must be at least 8 characters');
      isValid = false;
    }

    if (!passportNo || !validatePassportNumber(passportNo)) {
      toast.error('Passport number must be alphanumeric and 8-9 characters long');
      isValid = false;
    }

    if (!addressHome || addressHome.trim() === '') {
      toast.error('Address is required');
      isValid = false;
    }

    const isPhoneEmpty = (phone) => {
      // Check if there's no phone or if the number contains only the country code
      return !phone || /^\+\d{1,4}$/.test(phone.trim());
    };


    if (isPhoneEmpty(handPhone)) {
      toast.error('Mobile Phone number is required');
      isValid = false;
    }

    if (isPhoneEmpty(phoneHome)) {
      toast.error('Home Phone number is required');
      isValid = false;
    }

    if (!isValid) {
      return;
    }

    // Check if email already exists
    const emailAvailable = await checkEmailExists(email);

    if (!emailAvailable) {
      toast.error('Email already exists');
      return;
    }

    // Proceed to the next page
    setPage((prevPage) => prevPage + 1);
  };



  const prevPage = () => {
    setPage(page - 1);
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const nextPagewithApi = async () => {


    if (isSubmitting || retryingBatchFetch) return;

    if (!batchDataFetched) {
      // toast.error('Batch data is still loading. Retrying...');
      setRetryingBatchFetch(true);

      try {
        const response = await axios.get("/batch-summary");
        const batchData = response.data.find(batch => batch.id == batchId);

        if (batchData) {
          setEnType(batchData.type);
          const calculatedModule = handleDateChange(batchData);
          if (calculatedModule !== undefined) {
            setEnCurrentModule(calculatedModule);
            setBatchDataFetched(true);
          } else {
            console.warn("handleDateChange returned undefined");
          }
        } else {
          toast.error("Batch with the given ID not found");
        }
      } catch (error) {
        toast.error("Please check your internet connection and try again.");
        console.error("Retry error:", error);
      } finally {

        setTimeout(() => {
          setRetryingBatchFetch(false);
        }, 5000);
      }

      return; // Prevent further execution until retry is complete
    }



    setIsSubmitting(true);
    const requiredFields = [
      formData.studentName,
      formData.proofType
    ];
    if (formData.proofType === 'NRIC' || formData.proofType === 'FIN') {
      requiredFields.push(formData.nric);
    }
    const isFormValid = requiredFields.every(field => field && field.trim() !== '');
    const nricRegex = /^[STFGM][0-9]{7}[A-Z]$/;
    const finRegex = /^[STFGM][0-9]{7}[A-Z]$/;
    if (formData.proofType === 'NRIC' && !nricRegex.test(formData.nric)) {
      setError('Invalid NRIC format');
      setIsSubmitting(false);
      return;
    } else if (formData.proofType === 'FIN' && !finRegex.test(formData.nric)) {
      setError('Invalid FIN format');
      setIsSubmitting(false);
      return;
    } else {
      setError('');
    }
    if (!isFormValid) {
      toast.error('Please fill in all required fields.');
      setIsSubmitting(false);
      return;
    }
    try {
      console.log("Before request, NRIC:", formData.nric);
      const response = await axios.get(`/registrationadvances/alumni/${formData.nric}`);
      console.log("test response", response);
      const responseStatus = response.data.status;
      switch (responseStatus) {
        case 'active':
          setAlreadyRegistered(true);
          break;
        case 'new':
          setPage(prevPage => prevPage + 1);
          break;
        case 'register':
          toast.error('You are already registered');
          console.log("already registered");
          break;
        case 'Alumni':
          setDataResponse(response.data.details[0]);
          setEditedStudent(true);
          setFetchedOrNot(true);
          setAlreadyRegistered(true);
          break;
        case 'Pending':
        case 'Deferred':
        case 'rejected':
          setAdminMessage(responseStatus);
          setContactAdmin(true);
          break;
        default:
          console.log(responseStatus, "please contact");
      }


    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.log("404 Not Found, proceeding to next page");
        setPage(prevPage => prevPage + 1);
      } else {
        console.error('Error during API call:', error);
      }
    } finally {
      setIsSubmitting(false); // Re-enable button
    }
  };



  const handleContinue = () => {
    setAlreadyRegistered(false); // Close the modal
    setFormData((prevData) => ({
      ...prevData,
      studentName: dataResponse?.name || prevData.studentName,
      nric: dataResponse?.nricno || prevData.nric,
      // phone: dataResponse?.handPhone || prevData.phone,
      email: dataResponse?.email || prevData.email,
      gender: dataResponse?.gender || prevData.gender,
      dob: dataResponse?.dob || prevData.dob,
      // password: dataResponse.student.password || prevData.password,
      sureName: dataResponse?.sureName || prevData.sureName,
      countryBirth: dataResponse?.countryBirth || prevData.countryBirth,
      passportNo: dataResponse?.passportNo || prevData.passportNo,
      addressOffice: dataResponse?.addressOffice || prevData.addressOffice,
      addressHome: dataResponse?.addressHome || prevData.addressHome,
      phoneOffice: dataResponse?.phoneOffice || prevData.phoneOffice,
      phoneHome: dataResponse?.phoneHome || prevData.phoneHome,
      handPhone: dataResponse?.handPhone || prevData.handPhone,
      emergencyName: dataResponse?.emergencyName || prevData.emergencyName,
      emergencyRelation: dataResponse?.emergencyRelation || prevData.emergencyRelation,
      emergencyPhone: dataResponse?.emergencyPhone || prevData.emergencyPhone,
      knowAboutProgram: dataResponse?.knowAboutProgram || prevData.knowAboutProgram,
      applicationSignature: dataResponse?.applicationSignature || prevData.applicationSignature,
      nonSingaporean: dataResponse?.nonSingaporean || prevData.nonSingaporean,
      company: dataResponse?.company || prevData.company,
      institutionDetails: dataResponse?.institutionDetails.length > 0 ? dataResponse?.institutionDetails : prevData.institutionDetails,
      // institutionDetails: result.institutionDetails [] ,
    }));
    setPage((prevPage) => prevPage + 1);
  };

  const handleCloseModalforAlumni = () => {
    setAlreadyRegistered(false); // Close the modal
    setPage((prevPage) => prevPage + 1);

  };

  const handleCloseModal = () => {
    setAlreadyRegistered(false);
    setContactAdmin(false);
    setAdminMessage('');
  };



  const validateEmail = (value) => {
    // Example validation: Check if value is a valid email format
    return /\S+@\S+\.\S+/.test(value);
  };

  const validatePassword = (value) => {
    // Example validation: Check if value meets minimum length requirement
    return value.length >= 8;
  };

  const validatePassportNumber = (value) => {
    // Validate if value is alphanumeric and within specified length
    return /^[A-Z0-9]{8,9}$/.test(value);
  };

  const pageTitles = [
    "Identification Details",
    "Personal Details",
    "Educational Details",

  ];

  const handleCancel = () => {
    navigate('/');
  };


  const uniqueNationalities = Array.from(
    new Map(
      prioritizedCountriesList
        .filter((country) => nationalityMapping[country.name])
        .map((country) => [
          nationalityMapping[country.name], // Key: mapped nationality
          country.name,                     // Value: country name (for reverse lookup if needed)
        ])
    ).entries()
  ).map(([label, country]) => ({ label, country }));

  const [nationalityValid, setNationalityValid] = useState(true);


  const handleRedirect = () => {
    // Navigate to home page, assuming you're using react-router
    window.location.href = '/';
  };

  const handleConfirmationClose = (confirmed) => {
    if (confirmed) {
      handleRedirect();
    }
    setConfirmationOpen(false);
  };
  return (
    <Container component="main" maxWidth="md">
      <Paper elevation={3} sx={{ padding: 4, marginTop: 14 }}>
        <Box display="flex" justifyContent="center" mb={2}>
          <img
            id="imglogo"
            src={logoImage}
            alt="logoImage"
            style={{ maxWidth: '100%', height: 'auto' }} // Ensures the image scales properly
          />
        </Box>
        <Typography variant="h6" align="center" gutterBottom>
          {pageTitles[page]}
        </Typography>

        <form onSubmit={handleSubmit}>

          {page === 0 && (

            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} sm={6}>
                <Paper elevation={3} sx={{ padding: 4, marginTop: 4 }}>
                  <TextField
                    fullWidth
                    label="Full Name (as per NRIC/Work pass)"
                    name="studentName"
                    value={formData.studentName}
                    onChange={handleChange}
                    required
                    margin="normal"
                  />

                  <FormControl fullWidth margin="normal">
                    <InputLabel id="id-type-label">Select ID Type</InputLabel>
                    <Select
                      labelId="id-type-label"
                      label="Select ID Type"
                      name="proofType"
                      value={formData.proofType}
                      onChange={handleChange}
                      required
                    >



                      <MenuItem value="NRIC">NRIC</MenuItem>
                      <MenuItem value="FIN">FIN</MenuItem>
                    </Select>
                  </FormControl>

                  {['NRIC', 'FIN'].includes(formData.proofType) && (
                    <TextField
                      fullWidth
                      label={`Please enter ${formData.proofType}`}
                      name="nric"
                      value={formData.nric}
                      onChange={handleChange}
                      required
                      margin="normal"
                      inputProps={{
                        maxLength: 9
                      }}
                      error={Boolean(error)}
                      helperText={error}
                    />
                  )}

                  <FormControl fullWidth >

                    <InputLabel id="referrdby">Referred Teacher</InputLabel>
                    <Select
                      onChange={handleSelectChange}
                      label="Referred Teacher"
                      defaultValue=""
                    >
                      <MenuItem value=""><em>Select</em></MenuItem>
                      {users.map(user => (
                        <MenuItem key={user.id} value={user.name}>
                          {user.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {/* <FormControl fullWidth required>
                    <InputLabel id="gender">Gender</InputLabel>
                    <Select
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                      required
                      labelId="gender"
                      label="Gender"
                    >
                      <MenuItem value=""><em>Select</em></MenuItem>
                      <MenuItem value="Male">Male</MenuItem>
                      <MenuItem value="Female">Female</MenuItem>
                    </Select>
                  </FormControl> */}

                  <Grid container justifyContent="space-between" sx={{ marginTop: 3 }}>
                    <Grid item>
                      <Button variant="contained" color="primary" onClick={handleCancel}>
                        Close
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={nextPagewithApi}
                        disabled={isSubmitting || retryingBatchFetch || Boolean(error)}
                      >
                        {(isSubmitting || retryingBatchFetch) ? 'Loading...' : 'Next'}
                      </Button>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          )}

          {page === 1 && (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Full Name (As per NRIC / work pass)"
                  name="studentName"
                  value={formData.studentName}
                  onChange={handleChange}
                  required
                  disabled
                  type='text'
                  inputProps={{
                    maxLength: 25
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="NRIC/FIN"
                  name="nric"
                  value={formData.nric}
                  onChange={handleChange}
                  required
                  disabled
                  type='text'
                  inputProps={{
                    maxLength: 9
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <div style={{ position: "relative", width: "100%" }}>
                  <label
                    style={{
                      position: "absolute",
                      top: "-8px", // Always at the top
                      left: "12px",
                      fontSize: "0.8rem", // Smaller size for a floating-label effect
                      color: "grey", // Matches Material-UI's active label color
                      backgroundColor: "white",
                      padding: "0 4px", // Prevents overlap with input background
                      zIndex: 1,
                    }}
                  >
                    Mobile Phone*
                  </label>

                  <PhoneInput

                    // name="handPhone"
                    required
                    preferredCountries={["sg", "my", "in"]}
                    country={'sg'}
                    value={formData.handPhone}
                    onChange={(value, country) => {
                      // If user deleted everything (including country code), set it to empty
                      const cleaned = value.replace(/\D/g, '');
                      if (cleaned.length <= country.dialCode.length) {
                        setFormData(prev => ({ ...prev, handPhone: '' }));
                      } else {
                        setFormData(prev => ({
                          ...prev,
                          handPhone: `+${country.dialCode} ${value.slice(country.dialCode.length)}`
                        }));
                      }
                    }}
                    inputStyle={{
                      height: "55px",
                      width: "100%",
                      borderRadius: '5px'
                    }}
                    dropdownStyle={{
                      width: '250px'
                    }}

                  />
                </div>
              </Grid>


              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  error={emailError} // Use emailError to control the error state
                  helperText={emailError ? 'Email is either invalid or already in use' : ''} // Display appropriate message
                />

                {/* {emailError && <Typography color="error">Email already exists</Typography>} */}
              </Grid>


              <Grid item xs={12} sm={4}>
                <FormControl fullWidth required>
                  <InputLabel id="gender">Gender</InputLabel>
                  <Select
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    required
                    labelId="gender"
                    label="Gender"
                  >
                    <MenuItem value=""><em>Select</em></MenuItem>
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Date of Birth"
                  name="dob"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={formData.dob}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Create Password"
                  name="password"
                  type="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  error={formData.password && !validatePassword(formData.password)}
                  helperText={formData.password && !validatePassword(formData.password) ? 'Password must be at least 8 characters' : ''}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={(e) => e.preventDefault()} // Prevent focus loss
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{

                    "input::-ms-reveal, input::-ms-clear": {
                      display: "none",
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <Autocomplete
                  options={prioritizedCountriesList}
                  getOptionLabel={(option) => option.name}
                  value={
                    prioritizedCountriesList.find(
                      (country) => country.name === formData.countryBirth
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    const value = newValue ? newValue.name : '';
                    setCountryValid(!!value);
                    handleChange({
                      target: {
                        name: 'countryBirth',
                        value,
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Country of Birth"
                      required
                      fullWidth
                      error={!countryValid}
                      helperText={!countryValid ? 'Please select a valid country from the list' : ''}
                    />
                  )}
                  isOptionEqualToValue={(option, value) => option.name === value.name}
                  onBlur={() => {
                    // When user leaves the field, validate if the input matches one of the options
                    const isValid = prioritizedCountriesList.some(
                      (country) => country.name === formData.countryBirth
                    );
                    setCountryValid(isValid);
                  }}
                />
              </Grid>


              <Grid item xs={12} sm={4}>
                <Autocomplete
                  options={uniqueNationalities}
                  getOptionLabel={(option) => option.label}
                  value={
                    uniqueNationalities.find(
                      (item) => item.label === nationalityMapping[formData.nationality]
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    const value = newValue ? newValue.country : '';
                    setNationalityValid(!!value);
                    handleChange({
                      target: {
                        name: 'nationality',
                        value,
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Nationality"
                      required
                      fullWidth
                      error={!nationalityValid}
                      helperText={!nationalityValid ? 'Please select a valid nationality from the list' : ''}
                    />
                  )}
                  isOptionEqualToValue={(option, value) => option.label === value.label}
                  onBlur={() => {
                    const isValid = uniqueNationalities.some(
                      (item) => item.country === formData.nationality
                    );
                    setNationalityValid(isValid);
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Passport Number"
                  name="passportNo"
                  value={formData.passportNo}
                  onChange={handleChange}
                  inputProps={{
                    maxLength: 9
                  }}
                  required
                  error={formData.passportNo && !validatePassportNumber(formData.passportNo)}
                  helperText={formData.passportNo && !validatePassportNumber(formData.passportNo) ? 'Alphanumeric, 8-9 characters' : ''}
                />
              </Grid>


              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Home Address"
                  name="addressHome"
                  value={formData.addressHome}
                  onChange={handleChange}
                  required
                  type='text'

                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <div style={{ position: "relative", width: "100%" }}>
                  <label
                    style={{
                      position: "absolute",
                      top: "-8px", // Always at the top
                      left: "12px",
                      fontSize: "0.8rem", // Smaller size for a floating-label effect
                      color: "grey", // Matches Material-UI's active label color
                      backgroundColor: "white",
                      padding: "0 4px", // Prevents overlap with input background
                      zIndex: 1,
                    }}
                  >
                    Home Phone*
                  </label>

                  <PhoneInput

                    preferredCountries={["sg", "my", "in"]}
                    country={'sg'}
                    value={formData.phoneHome}
                    onChange={(value, country) => {
                      const cleaned = value.replace(/\D/g, '');
                      if (cleaned.length <= country.dialCode.length) {
                        setFormData(prev => ({ ...prev, phoneHome: '' }));
                      } else {
                        setFormData(prev => ({
                          ...prev,
                          phoneHome: `+${country.dialCode} ${value.slice(country.dialCode.length)}`
                        }));
                      }
                    }}
                    inputStyle={{
                      height: "55px",
                      width: "100%",
                      borderRadius: '5px'
                    }}
                    dropdownStyle={{
                      width: '250px'
                    }}

                  />
                </div>
              </Grid>
              {/* <Grid item xs={12} sm={4}>
                <PhoneInput
                  placeholder="Hand Phone "
                  specialLabel="Hand Phone*"
                  preferredCountries={["sg", "my", "in"]}
                  country={'sg'}
                  value={formData.handPhone}
                  onChange={(value, country) => setFormData({
                    ...formData,
                    handPhone: `+${country.dialCode} ${value.slice(country.dialCode.length)}`
                  })}
                  inputStyle={{
                    height: "55px",
                    width: "100%",
                    borderRadius: '5px'
                  }}
                />
              </Grid> */}
            </Grid>
          )}

          {page === 2 && (
            <Grid container spacing={3}>
              {/* Emergency Contact Section */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Emergency Contact Name"
                  name="emergencyName"
                  value={formData.emergencyName}
                  onChange={handleChange}
                  required
                  type='text'
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth required>
                  <InputLabel id="emergency-relation-label">Emergency Contact Relation</InputLabel>
                  <Select
                    labelId="emergency-relation-label"
                    name="emergencyRelation"
                    value={formData.emergencyRelation}
                    onChange={handleChange}
                    required
                    label="Emergency Contact Relation"
                  >
                    <MenuItem value="Friends">Friends</MenuItem>
                    <MenuItem value="Colleague">Colleague</MenuItem>
                    <MenuItem value="Parents">Parents</MenuItem>
                    <MenuItem value="Others">Others</MenuItem>

                  </Select>
                </FormControl>

              </Grid>
              {formData.emergencyRelation === 'Others' && (
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    name="emergencyOtherDetails"
                    label="Please Specify Relation Name"
                    value={formData.emergencyOtherDetails}
                    onChange={handleChange}
                  // margin="normal"
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <div style={{ position: "relative", width: "100%" }}>
                  <label
                    style={{
                      position: "absolute",
                      top: "-8px", // Always at the top
                      left: "12px",
                      fontSize: "0.8rem", // Smaller size for a floating-label effect
                      color: "grey", // Matches Material-UI's active label color
                      backgroundColor: "white",
                      padding: "0 4px", // Prevents overlap with input background
                      zIndex: 1,
                    }}
                  >
                    Emergency Contact number*
                  </label>

                  <PhoneInput

                    preferredCountries={["sg", "my", "in"]}
                    country={'sg'}
                    value={formData.emergencyPhone}
                    required
                    onChange={(value, country) => {
                      const cleaned = value.replace(/\D/g, '');
                      if (cleaned.length <= country.dialCode.length) {
                        setFormData(prev => ({ ...prev, emergencyPhone: '' }));
                      } else {
                        setFormData(prev => ({
                          ...prev,
                          emergencyPhone: `+${country.dialCode} ${value.slice(country.dialCode.length)}`
                        }));
                      }
                    }}
                    inputStyle={{
                      height: "55px",
                      width: "100%",
                      borderRadius: '5px'
                    }}
                    dropdownStyle={{
                      width: '250px'
                    }}
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth required>
                  <InputLabel id="know-about-program-label">How Did You Know About the Program?</InputLabel>
                  <Select
                    labelId="know-about-program-label"
                    name="knowAboutProgram"
                    value={formData.knowAboutProgram}
                    onChange={handleKnowAboutProgramChange}
                    required
                    label="How Did You Know About the Program?"
                  >
                    <MenuItem value="referral">Friends</MenuItem>
                    <MenuItem value="Jurong Academy Website">Jurong Academy Website</MenuItem>
                    <MenuItem value="Flyers">Flyers</MenuItem>
                    <MenuItem value="Newspaper Advertisement">Newspaper Advertisement</MenuItem>
                    <MenuItem value="other">Others</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                {formData.knowAboutProgram === 'other' && (
                  <TextField
                    fullWidth
                    name="otherDetails"
                    label="Please Specify"
                    value={formData.otherDetails}
                    onChange={handleOtherDetailsChange}
                  />
                )}
                {formData.knowAboutProgram === 'referral' && (
                  <TextField
                    fullWidth
                    name="referalfriend"
                    label="Please Specify Name"
                    value={formData.referalfriend}
                    onChange={handleReferalFriendChange}
                  />
                )}
              </Grid>

              {/* Company Details Section */}
              <Grid item xs={12}>
                <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 'bold' }}>
                  Company Details
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Company Name"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  required={formData.proofType === 'FIN'}
                  type='text'
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Designation"
                  name="designation"
                  value={formData.designation}
                  onChange={handleChange}
                  required={formData.proofType === 'FIN'}
                  type='text'
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Company Address"
                  name="addressOffice"
                  value={formData.addressOffice}
                  onChange={handleChange}
                  required={formData.proofType === 'FIN'}
                  type='text'
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <div style={{ position: "relative", width: "100%" }}>
                  <label
                    style={{
                      position: "absolute",
                      top: "-8px", // Always at the top
                      left: "12px",
                      fontSize: "0.8rem", // Smaller size for a floating-label effect
                      color: "grey", // Matches Material-UI's active label color
                      backgroundColor: "white",
                      padding: "0 4px", // Prevents overlap with input background
                      zIndex: 1,
                    }}
                  >
                    Company Contact number*
                  </label>

                  <PhoneInput

                    preferredCountries={["sg", "my", "in"]}
                    country={'sg'}
                    required={formData.proofType === 'FIN'}
                    value={formData.phoneOffice}
                    onChange={(value, country) => setFormData({
                      ...formData,
                      phoneOffice: `+${country.dialCode} ${value.slice(country.dialCode.length)}`
                    })}
                    inputStyle={{
                      height: "55px",
                      width: "100%",
                      borderRadius: '5px'
                    }}
                    dropdownStyle={{
                      width: '250px'
                    }}

                  />
                </div>
              </Grid>

              {/* Educational Details Section */}
              <Grid item xs={12}>
                <Grid item xs={12}>
                  <Typography
                    variant="h5"
                    gutterBottom
                    align="center"
                    sx={{ fontWeight: 'bold' }}
                  >
                    Educational Details
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Grid container justifyContent="flex-end">
                    <Button
                      variant="contained"
                      startIcon={<Add />}
                      onClick={addInstitution}

                      sx={{
                        backgroundColor: buttonBackgroundColor
                      }}
                    >
                      Add Qualification
                    </Button>
                  </Grid>
                </Grid>

              </Grid>
              {formData.institutionDetails.length > 0 &&
                formData.institutionDetails.map((institution, index) => (
                  <Grid container spacing={3} key={index}>
                    <Grid item xs={12}>
                      <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Education {index + 1}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Institution"
                        name="institution"
                        value={institution.institution}
                        onChange={(e) => handleInstitutionChange(index, e)}

                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Year"
                        name="year"
                        value={institution.year}
                        onChange={(e) => handleInstitutionChange(index, e)}

                      />
                    </Grid>
                    {/* <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      label="To Year"
                      name="toYear"
                      value={institution.toYear}
                      onChange={(e) => handleInstitutionChange(index, e)}
                      required
                    />
                  </Grid> */}
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth >
                        <InputLabel id={`full-time-part-time-label-${index}`}>Full Time or Part Time</InputLabel>
                        <Select
                          labelId={`full-time-part-time-label-${index}`}
                          label="Full Time or Part Time"
                          name="fullTimeOrPartTime"
                          value={institution.fullTimeOrPartTime}
                          onChange={(e) => handleInstitutionChange(index, e)}
                        >
                          <MenuItem value="Full Time">Full Time</MenuItem>
                          <MenuItem value="Part Time">Part Time</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Qualifications Achieved"
                        name="qualificationsAchieved"
                        value={institution.qualificationsAchieved}
                        onChange={(e) => handleInstitutionChange(index, e)}

                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Tooltip title="Remove Institution">
                        <Button color="secondary" sx={{
                          backgroundColor: "#dc3545", // Red color (Bootstrap Danger)
                          color: "white",
                          "&:hover": {
                            backgroundColor: "#c82333", // Darker shade for hover
                          },
                        }}
                          onClick={() => removeInstitution(index)}>
                          Remove
                        </Button>
                      </Tooltip>
                    </Grid>
                  </Grid>
                ))}




              <Grid item xs={12}>
                <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }} align="center">
                  Documents Submission
                </Typography>

              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TableContainer component={Paper} style={{ marginBottom: '20px', width: '100%', overflowX: 'auto' }}>
                    <Table aria-label="file upload table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Items</TableCell>
                          <TableCell>Documents (File Upload)</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>File Name</TableCell> {/* New column */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {formData.institutionDetails.map((institution, index) => (
                          <TableRow key={index}>
                            <TableCell>Mark Sheet for {institution.institution}</TableCell>
                            <TableCell>
                              <Button
                                variant="contained"
                                component="label"
                                fullWidth
                                style={{
                                  backgroundColor: buttonBackgroundColor,
                                  color: 'white',
                                }}
                                // required
                                onClick={() => resetUpload(`markSheet-${index}`)}
                              >
                                {loadingButton === `markSheet-${index}` ? (
                                  <CircularProgress size={24} color="inherit" />
                                ) : (
                                  formData.markSheet[`level${index + 1}`] ? "Re-upload" : "Upload"
                                )}
                                <input
                                  type="file"
                                  name={`markSheet-${index}`}
                                  hidden
                                  accept=".jpg, .jpeg, .png, .pdf,.docx,"
                                  onChange={(e) => handleFileUpload(e, `markSheet-${index}`, index)}
                                />
                                {formData.markSheet[`level${index + 1}Progress`] > 0 && formData.markSheet[`level${index + 1}Progress`] < 100 && (
                                  <LinearProgress variant="determinate" value={formData.markSheet[`level${index + 1}Progress`]} style={{ marginTop: '8px' }} />
                                )}
                              </Button>
                              <span style={{ fontSize: '0.80rem', color: 'blue', marginTop: '8px' }}>
                                Supported file types pdf,doc,img,jpeg*
                              </span>
                            </TableCell>
                            <TableCell>{formData.markSheet[`level${index + 1}Status`]}</TableCell>
                            <TableCell>{formData.markSheetFileNames[`level${index + 1}`]}</TableCell> {/* New cell */}
                          </TableRow>
                        ))}
                        {formData.institutionDetails.map((institution, index) => (
                          <TableRow key={index}>
                            <TableCell>Certificate for {institution.institution}</TableCell>
                            <TableCell>
                              <Button
                                variant="contained"
                                component="label"
                                fullWidth
                                style={{
                                  backgroundColor: buttonBackgroundColor,
                                  color: 'white',
                                }}
                                // required
                                onClick={() => resetUpload(`certificate-${index}`)}
                              >
                                {loadingButton === `certificate-${index}` ? (
                                  <CircularProgress size={24} color="inherit" />
                                ) : (
                                  formData.certificate[`level${index + 1}`] ? "Re-upload" : "Upload"
                                )}                                <input
                                  type="file"
                                  name={`certificate-${index}`}
                                  hidden
                                  accept=".jpg, .jpeg, .png, .pdf,.docx"
                                  onChange={(e) => handleFileUpload(e, `certificate-${index}`, index)}
                                />
                                {formData.certificate[`level${index + 1}Progress`] > 0 && formData.certificate[`level${index + 1}Progress`] < 100 && (
                                  <LinearProgress variant="determinate" value={formData.certificate[`level${index + 1}Progress`]} style={{ marginTop: '8px' }} />
                                )}
                              </Button>
                              <span style={{ fontSize: '0.80rem', color: 'blue', marginTop: '8px' }}>
                                Supported file types pdf,doc,img,jpeg*
                              </span>
                            </TableCell>
                            <TableCell>{formData.certificate[`level${index + 1}Status`]}</TableCell>
                            <TableCell>{formData.certificateFileNames[`level${index + 1}`]}</TableCell> {/* New cell */}
                          </TableRow>
                        ))}
                        <TableRow>
                          <TableCell>NRIC/Work Permit</TableCell>
                          <TableCell>
                            {/* Upload for workPermitSpass */}
                            <Button
                              variant="contained"
                              component="label"
                              fullWidth
                              required
                              style={{
                                backgroundColor: buttonBackgroundColor,
                                color: 'white',
                              }}
                              onClick={() => resetUpload('workPermitSpass')}
                            >
                              {loadingButton === "workPermitSpass" ? (
                                <CircularProgress size={24} color="inherit" />
                              ) : (
                                formData.workPermitSpass ? "Re-upload Work Permit front" : "Upload Work Permit front"
                              )}                              <input
                                type="file"
                                name="workPermitSpass"
                                hidden
                                accept=".jpg, .jpeg, .png, .pdf,.docx,"
                                onChange={(e) => handleFileUpload(e, 'workPermitSpass')}
                              />
                              {formData.workPermitSpassProgress > 0 && formData.workPermitSpassProgress < 100 && (
                                <LinearProgress variant="determinate" value={formData.workPermitSpassProgress} style={{ marginTop: '8px' }} />
                              )}
                            </Button>


                            <Button
                              variant="contained"
                              component="label"
                              fullWidth
                              required
                              style={{
                                marginTop: '10px',
                                backgroundColor: buttonBackgroundColor,
                                color: 'white',
                              }}
                              onClick={() => resetUpload('workPermitOne')}
                            >
                              {loadingButton === "workPermitOne" ? (
                                <CircularProgress size={24} color="inherit" />
                              ) : (
                                formData.workPermitOne ? "Re-upload Work Permit back" : "Upload Work Permit back"
                              )}                              <input
                                type="file"
                                name="workPermitOne"
                                hidden
                                accept=".jpg, .jpeg, .png, .pdf,.docx,"
                                onChange={(e) => handleFileUpload(e, 'workPermitOne')}
                              />
                              {formData.workPermitOneProgress > 0 && formData.workPermitOneProgress < 100 && (
                                <LinearProgress variant="determinate" value={formData.workPermitOneProgress} style={{ marginTop: '8px' }} />
                              )}
                            </Button>

                            <span style={{ fontSize: '0.80rem', color: 'blue', marginTop: '8px', display: 'block' }}>
                              Supported file types: pdf, doc, img, jpeg*
                            </span>


                            {errors.workPermitSpass && (
                              <span style={{ color: 'red', fontSize: '0.80rem', marginTop: '8px' }}>
                                Please upload the Work Permit front file before submitting.
                              </span>
                            )}
                            {errors.workPermitOne && (
                              <span style={{ color: 'red', fontSize: '0.80rem', marginTop: '8px' }}>
                                Please upload the Work Permit back file before submitting.
                              </span>
                            )}
                          </TableCell>


                          <TableCell>
                            {formData.workPermitSpassStatus && <div>{formData.workPermitSpassStatus}</div>}
                            {formData.workPermitOneStatus && <div>{formData.workPermitOneStatus}</div>}
                          </TableCell>

                          <TableCell>
                            {formData.workPermitSpassFileName && <div>{formData.workPermitSpassFileName}</div>}
                            {formData.workPermitOneFileName && <div>{formData.workPermitOneFileName}</div>}
                          </TableCell>
                        </TableRow>


                        <TableRow>
                          <TableCell>Passport</TableCell>
                          <TableCell>
                            <Button
                              variant="contained"
                              component="label"
                              fullWidth
                              style={{
                                backgroundColor: buttonBackgroundColor,
                                color: 'white',
                              }}
                              // required
                              onClick={() => resetUpload('passport')}
                            >
                              {loadingButton === "passport" ? (
                                <CircularProgress size={24} color="inherit" />
                              ) : (
                                formData.passport ? "Re-upload" : "Upload"
                              )}                              <input
                                type="file"
                                name="passport"
                                hidden
                                accept=".jpg, .jpeg, .png, .pdf"
                                onChange={(e) => handleFileUpload(e, 'passport')}
                              />
                              {formData.passportProgress > 0 && formData.passportProgress < 100 && (
                                <LinearProgress variant="determinate" value={formData.passportProgress} style={{ marginTop: '8px' }} />
                              )}
                            </Button>
                            <span style={{ fontSize: '0.80rem', color: 'blue', marginTop: '8px' }}>
                              Supported file types pdf,doc,img,jpeg*
                            </span>
                          </TableCell>
                          <TableCell>{formData.passportStatus}</TableCell>
                          <TableCell>{formData.passportFileName}</TableCell> {/* New cell */}
                        </TableRow>

                        <TableRow>
                          <TableCell>Passport Size Photo</TableCell>
                          <TableCell>
                            <Button
                              variant="contained"
                              component="label"
                              fullWidth
                              style={{
                                backgroundColor: buttonBackgroundColor,
                                color: 'white',
                              }}
                              onClick={() => resetUpload('profilePicture')}
                            >
                              {loadingButton === "profilePicture" ? (
                                <CircularProgress size={24} color="inherit" />
                              ) : (
                                formData.profilePicture ? "Re-upload" : "Upload"
                              )}                              <input
                                type="file"
                                name="profilePicture"
                                hidden
                                accept=".jpg, .jpeg, .png ,.pdf"
                                onChange={(e) => handleFileUpload(e, 'profilePicture')}
                              />
                              {formData.profilePictureProgress > 0 && formData.profilePictureProgress < 100 && (
                                <LinearProgress
                                  variant="determinate"
                                  value={formData.profilePictureProgress}
                                  style={{ marginTop: '8px' }}
                                />
                              )}
                            </Button>
                            <span style={{ fontSize: '0.80rem', color: 'blue', marginTop: '8px' }}>
                              Supported file types: .jpg, .jpeg, .png,.pdf
                            </span>
                          </TableCell>
                          <TableCell>{formData.profilePictureStatus}</TableCell>
                          <TableCell>{formData.profilePictureFileName}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>



            </Grid>
          )}
          <Grid container spacing={2} sx={{ marginTop: 3 }}>
            {page === 1 && (
              <>
                <Grid item xs={6}>
                  <Button variant="outlined" onClick={prevPage} fullWidth>
                    Previous
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button variant="outlined" onClick={nextPage} fullWidth style={{
                    backgroundColor: buttonBackgroundColor,
                    color: 'white',
                  }} >
                    Next
                  </Button>
                </Grid>
              </>
            )}
            {page === 2 && (
              <>
                <Grid item xs={6}>
                  <Button variant="outlined" onClick={prevPage} fullWidth>
                    Previous
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button type="submit" variant="contained" color="primary" disabled={loading} fullWidth style={{
                    backgroundColor: buttonBackgroundColor,
                    color: 'white',
                  }}>
                    Submit
                  </Button>
                </Grid>
              </>
            )}
          </Grid>
        </form>

        <Dialog
          open={open}
          onClose={() => { }}
          maxWidth="sm"
          PaperProps={{ style: { borderRadius: 15, overflow: 'hidden' } }}
          disableEscapeKeyDown
          disableBackdropClick // For MUI v4
        // For MUI v5+, use this instead of disableBackdropClick:
        // onClose={(event, reason) => {
        //   if (reason !== 'backdropClick') {
        //     setOpen(false);
        //   }
        // }}
        >
          <DialogContent>
            {submissionSuccess ? (
              <Slide direction="up" in={submissionSuccess} mountOnEnter unmountOnExit>
                <Box textAlign="center" py={4}>
                  <CheckCircleIcon style={{ fontSize: 60, color: 'green' }} />
                  <Typography variant="h5" gutterBottom>
                    Form Submitted Successfully!
                  </Typography>
                  <Typography variant="body1" color="textSecondary" mb={3}>
                    You will receive an email once your application is approved.
                  </Typography>

                  <Typography variant="body1" mb={2}>
                    Do you want to go to the homepage?
                  </Typography>

                  <Button variant="contained" color="primary" onClick={() => (window.location.href = '/')}>
                    Go to Home Page
                  </Button>
                </Box>
              </Slide>
            ) : (
              <Box textAlign="center" py={4}>
                <CircularProgress />
                <Typography variant="h6" style={{ marginTop: 20 }}>
                  Submitting Your Form...
                </Typography>
              </Box>
            )}
          </DialogContent>
        </Dialog>




      </Paper>

      {/* Modal component for already registered */}
      <Modal
        open={alreadyRegistered || contactAdmin} // <-- open if alreadyRegistered OR contactAdmin
        onClose={handleCloseModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 300,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
        }}>
          {contactAdmin ? ( // <-- Check if it's contactAdmin modal
            <>
              <Typography id="modal-title" variant="h6" component="h2">
                {`Application Status: ${adminMessage}`} {/* Show status here */}
              </Typography>
              <Typography id="modal-description" sx={{ mt: 2 }}>
                Your application status is <strong>{adminMessage}</strong>. Please contact the administrator for further assistance.
              </Typography>
              <Button onClick={handleCloseModal} variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
                Close
              </Button>
            </>
          ) : editedStudent ? (
            <>
              <Typography id="modal-title" variant="h6" component="h2">
                Welcome back
              </Typography>
              <Button onClick={handleContinue} variant="contained" color="primary" fullWidth>
                Continue
              </Button>
              <Button onClick={handleCloseModalforAlumni} variant="contained" color="primary" fullWidth>
                Close
              </Button>
            </>
          ) : (
            <>
              <Typography id="modal-title" variant="h6" component="h2">
                You are Already Active Student
              </Typography>
              <Button onClick={handleCloseModal} variant="contained" color="primary" fullWidth>
                Close
              </Button>
            </>
          )}
        </Box>
      </Modal>


      <ToastContainer />
    </Container>
  );
}

export default App;

